import { Fragment } from "react";
import { DropZone } from "@measured/puck";

import { useGridLayout } from "./hooks/useGridLayout";
import { generateZoneId, ALLOWED_BLOCK_TYPES } from "./utils/gridUtils";
import { GridBlockProps } from "./types";
import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const GridBlock = (props: GridBlockProps) => {
    const { id = "", columns = 2, rows = 1, spacing = 2, grow = false, columnWidth = "equal" } = props;
    const { colIndices, rowIndices, gridStyle } = useGridLayout({
        columns,
        rows,
        spacing,
        grow,
        columnWidth,
    });
    const theme = useTheme();

    return (
        <div style={gridStyle} data-grid-id={id}>
            {rowIndices.map((rowIndex) => (
                <Fragment key={`${id}-row-${rowIndex}`}>
                    {colIndices.map((colIndex) => {
                        const zoneId = generateZoneId(rowIndex, colIndex);
                        return (
                            <Stack
                                key={`${id}-cell-${rowIndex}-${colIndex}`}
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    justifySelf: "center",
                                    minHeight: "300px",
                                    maxWidth: theme.breakpoints.values.xl,
                                }}
                            >
                                <DropZone zone={zoneId} allow={ALLOWED_BLOCK_TYPES} />
                            </Stack>
                        );
                    })}
                </Fragment>
            ))}
        </div>
    );
};
